var app = angular.module("leonardo");

var UnitTypeForm = function($scope, $rootScope, UnitTypeService, AccountUserService, FormErrorsService) {
  $scope.mode = $scope.ngDialogData.mode;
  $scope.unit_type = $scope.ngDialogData.unit_type;

  if ($scope.mode === 'edit')
    $scope.data = angular.copy($scope.unit_type);
  else
    $scope.data = {
      account: $scope.ngDialogData.account
    };

  $scope.submit = function() {
    $scope.Form.$setSubmitted();
    if ($scope.Form.$invalid) {
      FormErrorsService.goToError();
      return;
    }
    if ($scope.mode === 'edit'){
      $scope.unit_type.patch($scope.data).then(function(){
        $rootScope.$broadcast('unit_type:updated');
        $scope.closeThisDialog();
      });
    }
    else {
      var data = angular.copy($scope.data);
      UnitTypeService.post(data).then(function(result) {
        UnitTypeService.updateCollection(result);
        $rootScope.$broadcast('unit_type:created');
        $scope.closeThisDialog();
      });
    }
  };
};

app.controller('UnitTypeForm', ['$scope', '$rootScope', 'UnitTypeService', 'AccountUserService', 'FormErrorsService', UnitTypeForm]);
